import React, {useState, useEffect, useRef} from "react";
import routes from "./routes";
import {Routes, Route, useRoutes, useLocation, useParams, Outlet} from "react-router-dom";
import {withProtectedLayout} from "./withProtectedLayout";
import ProtectedRoute from "./Components/ProtectedRoute";
import ProtectedAdminRoute from "./Components/ProtectedAdminRoute";
import AuthRoute from "./Components/AuthRoute";
import config from "./config";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import Login from "./Pages/Login";
import Dashboard from "./Pages/Dashboard";
import Register from "./Pages/Registration";

import AdminLogin from "./Pages/AdminLogin";
import VerifyAdminEmailChange from "./Pages/VerifyAdminEmailChange";
import AdminAccessCode from "./Pages/AdminAccessCode";
// import AdminSwipeCreditCard from "./Pages/AdminSwipeCreditCard";
import Transaction from "./Pages/AdminDashboard/Transaction";
import AdminDashboard from "./Pages/AdminDashboard/AdminDashboard";
import AdminRegistration from "./Pages/AdminRegistration";
import Payments from "./Pages/Payments";
import LoginWithToken from "./Pages/LoginWithToken";
import ForgotPassword from "./Pages/ForgotPassword";
import UpdatePassword from "./Pages/UpdatePassword";
import Users from "./Pages/AdminDashboard/PayersTable.js";
import UpdateEmailRequest from "./Pages/UpdateEmailRequest";
import UpdateEmail from "./Pages/UpdateEmail";
import AdminHelloTest from "./Pages/AdminHelloTest/index.js";
import AccessCode from "./Pages/AccessCode";
import SendLinkEmail from "./Pages/SendLinkAdmin";
import UpdatePasswordAdmin from "./Pages/UpdatePasswordAdmin";
import LoginAdminWithToken from "./Pages/LoginAdminWithToken";
import Support from "./Pages/Suppoter";
import {ViewAppointment} from "./Refactor/Appointment/View/view-appointment";
import Forms from "./Pages/AdminDashboard/Forms";
import UserForms from "./Pages/Dashboard/UserForms";
import packageJson from '../package.json';

const VersionPage = () => (
    <div style={{padding: '40px', fontFamily: 'monospace'}}>
        <h2>sosfront</h2>
        <p>Version: {packageJson.version}</p>
    </div>
);


const VersionCheck = () => {
    const [isLatestVersion, setIsLatestVersion] = useState(true);
    const appVersion = useRef(localStorage.getItem('APP_VERSION') || '');

    useEffect(() => {
        const fetchMeta = () => {
            fetch('/meta.json', { cache: 'no-store' })
                .then((res) => {
                    if (!res.ok) return;
                    return res.json();
                })
                .then((meta) => {
                    if (!meta?.version) return;
                    if (!appVersion.current) {
                        appVersion.current = meta.version;
                        localStorage.setItem('APP_VERSION', meta.version);
                    } else if (meta.version !== appVersion.current) {
                        setIsLatestVersion(false);
                    }
                })
                .catch(() => {});
        };
        fetchMeta();
        const interval = setInterval(fetchMeta, 60000);
        return () => clearInterval(interval);
    }, []);

    const emptyCacheStorage = async () => {
        if ('caches' in window) {
            const keys = await window.caches.keys();
            await Promise.all(keys.map((key) => window.caches.delete(key)));
        }
        localStorage.setItem('APP_VERSION', '');
        window.location.replace(window.location.href);
    };

    if (isLatestVersion) return null;
    return (
        <p className="version-btn">
            <a href="#" onClick={(e) => { e.preventDefault(); emptyCacheStorage(); }}>
                Update version
            </a>
        </p>
    );
};


function ProtectedRoutes() {
    const protectedRoutes = useRoutes([
        {
            path: "/home",
            element: <Dashboard/>,
            isProtected: true,
            isAuthPage: false,
            isProtectedLayout: false,
        },
    ]);
}

const redirectUrl =
    window.location.origin === "https://www.sosoftpay.dev" ||
    window.location.origin === "https://sosoftpay.dev" ||
    window.location.origin === "https://sosoftpay.com" ||
    window.location.origin === "https://www.sosoftpay.com";


const SubdomainLayout = () => {
    const { subdomain } = useParams();
    return (
        <div>
            {/* Optional debug: show subdomain */}
            {/* <h1>Subdomain: {subdomain}</h1> */}
            <Outlet /> {/* Renders nested child route */}
        </div>
    );
};

function RoutesReactRouter6() {
    const absoluteRoutes = [
        {path: '/home', element: <ProtectedRoute><Dashboard/></ProtectedRoute>},
        {path: '/payments', element: <ProtectedRoute><Payments/></ProtectedRoute>},
        {path: '/forms', element: <ProtectedRoute><Dashboard/></ProtectedRoute>},
        {path: '/statement', element: <ProtectedRoute><Dashboard/></ProtectedRoute>},

        {path: '/admin', element: <AdminLogin/>},
        {path: '/adminDashboard', element: <ProtectedAdminRoute><AdminDashboard/></ProtectedAdminRoute>},
        {path: '/adminDashboard/settings', element: <ProtectedAdminRoute><AdminDashboard/></ProtectedAdminRoute>},
        {path: '/adminDashboard/allAdmins', element: <ProtectedAdminRoute><AdminDashboard/></ProtectedAdminRoute>},
        {path: '/adminDashboard/transactions', element: <ProtectedAdminRoute><AdminDashboard/></ProtectedAdminRoute>},
        {path: '/adminDashboard/reconcile', element: <ProtectedAdminRoute><AdminDashboard/></ProtectedAdminRoute>},
        {path: '/adminDashboard/reconcile/:date', element: <ProtectedAdminRoute><AdminDashboard/></ProtectedAdminRoute>},
        {path: '/adminDashboard/settlements', element: <ProtectedAdminRoute><AdminDashboard/></ProtectedAdminRoute>},
        {path: '/adminDashboard/forms', element: <ProtectedAdminRoute><AdminDashboard/></ProtectedAdminRoute>},
        {path: '/adminDashboard/statements', element: <ProtectedAdminRoute><AdminDashboard/></ProtectedAdminRoute>},
        {path: '/adminDashboard/allPayers', element: <ProtectedAdminRoute><AdminDashboard/></ProtectedAdminRoute>},
        {path: '/adminDashboard/payments', element: <ProtectedAdminRoute><AdminDashboard/></ProtectedAdminRoute>},

        {path: '/transaction', element: <ProtectedAdminRoute><Transaction/></ProtectedAdminRoute>},
        {path: '/users', element: <ProtectedAdminRoute><Users/></ProtectedAdminRoute>},

        {path: '/login', element: <Login/>},
        {path: '/register', element: <Register/>},
        {path: '/verifyAdminEmailChange/:tokenHash', element: <VerifyAdminEmailChange/>},
        {path: '/verifyAdminEmailChangeResult', element: <VerifyAdminEmailChange/>},
        {path: '/adminAccessCode', element: <AdminAccessCode/>},
        {path: '/loginAdmin/:userLoginToken', element: <LoginAdminWithToken/>},
        {path: '/adminRegistration', element: <AdminRegistration/>},
        {path: '/loginWithToken/:userToken', element: <LoginWithToken/>},
        {path: '/accessCode', element: <AccessCode/>},
        {path: '/forgotPassword', element: <ForgotPassword/>},
        {path: '/updatepassword/:userToken', element: <UpdatePassword/>},
        {path: '/updatepasswordAdmin/:tokenHash', element: <UpdatePasswordAdmin/>},
        {path: '/updateEmailRequest', element: <UpdateEmailRequest/>},
        {path: '/updateEmail/:updateEmailTokenHash', element: <UpdateEmail/>},
        {path: '/sendlink', element: <SendLinkEmail/>},
        {path: '/appointment', element: <ViewAppointment/>},
        {path: '/adminhellotest/:debugurl', element: <AdminHelloTest/>},
        {path: '/version', element: <VersionPage/>},
    ];

    if (config.APP_TYPE !== "local") {
        const rootRoute = {path: '/', element: (redirectUrl ? <Support/> : <Login/>)};
        return useRoutes([rootRoute, ...absoluteRoutes]);
    }

    if (config.APP_TYPE === "local") {
        // In local dev, keep subdomain routing for testing
        const rootRoute = { path: '/', element: <Support /> };
        const relativeRoutes = absoluteRoutes.map(route => ({
            ...route,
            path: route.path?.slice(1),
        }));
        const allTheRoutes = [
            {
                path: ':subdomain/*',
                element: <SubdomainLayout />,
                children: relativeRoutes
            }
        ];
        return useRoutes([rootRoute, ...allTheRoutes]);
    }

    // console.dir(config.APP_TYPE);
    // In production, flatten all routes
    // if (config.APP_TYPE !== "local") {




}


const App = () => {
    const loc = useLocation();
    return (
        <div>
            <RoutesReactRouter6/>
            <VersionCheck />
        </div>
    );
};

export default App;
